import { render } from "./FlashNotification.vue?vue&type=template&id=03b345b8&scoped=true"
import script from "./FlashNotification.vue?vue&type=script&lang=js"
export * from "./FlashNotification.vue?vue&type=script&lang=js"

import "./FlashNotification.vue?vue&type=style&index=0&id=03b345b8&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b345b8"]])

export default __exports__